<template>
	<div id="audit-panel" class="container panel">
		<div class="row">
			<div class="col-md-3 sidebar">
				<side-bar></side-bar>
			</div>

			<div class="col-md-9 content">
				<dash-head class="mb-3" title="Audits" subtitle="Password Security Portal"></dash-head>		

				<table-actions placeholder="search results" @search-changed="searchChanged" hideEdit="true" hideDelete="true">
				</table-actions>
				
				<table-view id="audit-results">
					<table-row slot="header">
						<table-header @click-header="sortByDate" sort="descending">Date</table-header>
						<table-header @click-header="sortByDomain" sort="none">Domain</table-header>
        				<table-header @click-header="sortByTotalAccounts" sort="none">Total Accounts</table-header>
        				<table-header @click-header="sortByToolVersion" sort="none">Tool Version</table-header>
					</table-row>
					<table-row slot="body" v-for="result in results" :key="result.rowKey" :class="{selected: result === resultFound}">
						<table-cell>{{result.date.toLocaleDateString()}}</table-cell>
						<table-cell><a :href="`#/audit/${result.rowKey}`">{{result.domain}}</a></table-cell>
						<table-cell>{{result.total}}</table-cell>
						<table-cell>{{result.version}}</table-cell>
					</table-row>
				</table-view>

				<div class="row">
					<div class="col-md-6">
						<table-pagination :page="page" :total="totalRows" :pageSize="pageSize" @page-changed="pageChanged"></table-pagination>
					</div>
					<div class="col-md-6">
						<div class="text-right">
						</div>
					</div>
				</div>

			</div>
		</div>	
	</div>
</template>

<script>
	import SideBar from './SideBar'
	import DashHead from './DashHead'
	import TableActions from './TableActions'
	import TableView from './TableView'
	import TableRow from './TableRow'
	import TableHeader from './TableHeader'
	import TableCell from './TableCell'
	import TablePagination from './TablePagination'

	import api from '../api'
	import router from '../router'
	import store from '../state'

	export default {
		name: 'AuditPanel',
		props: ['pageSize'],
		components: {SideBar, DashHead, TableActions, TableView, TableRow, TableHeader, TableCell, TablePagination},
		data() {
			return {
				error: null,
				resultFound: null,
				search: '',
				page: 1
			}
		},
		methods: {
			sortByDate(direction) {
				this.sortByPropertyNumeric(direction, 'date');				
			},
			sortByDomain(direction) {
				this.sortByProperty(direction, 'domain');
			},
			sortByTotalAccounts(direction) {
				this.sortByPropertyNumeric(direction, 'total');				
			},
			sortByToolVersion(direction) {
				this.sortByProperty(direction, 'version');				
			},
			sortByProperty(direction, name) {		
				const data = this.audits;

				if (direction === 'ascending') {
					data.sort(function (a,b) {
						if (a[name] === b[name]) return 0;
						return (a[name] > b[name]) ? 1 : -1;
					});
				}
				else {
					data.sort(function (a,b) {
						if (b[name] === a[name]) return 0;
						return (b[name] > a[name]) ? 1 : -1;
					});

				}
				this.page = 1;
			},
			sortByPropertyNumeric(direction, name) {			
				const data = this.audits;

				if (direction === 'ascending') {
					data.sort((a,b) => a[name] - b[name]);
				}
				else {					
					data.sort((a,b) => b[name] - a[name]);
				}
				this.page = 1;
			},
			searchChanged(value) {
				this.search = value.toLowerCase();
				this.page = 1;

				return;
			},
			pageChanged(value) {
				this.page = value;
			}
		},
		computed: {
			totalRows() {
				return this.filteredAudits.length;
			},
			audits() {
				return store.state.audits;
			},
			filteredAudits() {
				if (!this.audits) return [];
				if (!this.search) return this.audits;
				return this.audits.filter(value => value.domain.includes(this.search));
			},
			results() {
				const start = (this.page-1) * this.pageSize;		
				const results = [];								

				for (var audit of this.filteredAudits.slice(start, start + this.pageSize)) {				
					results.push(audit);
				}

				return results;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/AuditPanel.vue